<script>
// import Input from "@/components/c-input";
// import Select from "@/components/c-select";
// import TermRow from "@/components/term-row";
// import { servicehelpers } from "../../services/servicehelpers";
// import { paymenttermService } from "../../services/paymentservice/paymentterm.service";
import i18n from "../../i18n";

/* eslint-disable no-console */
/**
 * Item List component
 */
export default {
  components: {
    // Input,
    // Select,
    // TermRow,
  },
  data() {
    return {

    };
  },
  mounted() {
    
  },
  methods: {
    show: function() {
      this.$refs[this.id].show();
    },
    getTitle: function() {
      
      return `${i18n.t('setting.property.payment-term.text')}`
    },

    formatCurrency(value) {

      let sign = '$';
      let decimal = '.00';
      return this.filters.numFormat(value, `${sign}0,0${decimal}`);

    },
    

  },
  props: {
    id: {
      type: String,
    },
    item: {
      type: Object,
    },
    title: {
      type: String,
    },
    filters: null,  
    selectChangePaymentTerm: null,
    amount: {
      type: Number,
      default: 0
    },
    schedule: [],
  },
};
</script>
<template>
  <div>
      <b-modal
        :id="id"
        :ref="id"
        centered
        size="xl"
        :title='getTitle()'
        title-class="font-22"
        hide-footer
        :hide-header-close="true"
      >

        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-1">
                    {{$t('sale.schedule.no')}}
                  </div>
                  <div class="col-md-3">
                    {{$t('sale.schedule.date')}}
                  </div>
                  <div class="col-md-2">
                    {{$t('sale.schedule.paid')}}
                  </div>
                  <div class="col-md-2">
                    {{$t('sale.schedule.interest')}}
                  </div>
                  <div class="col-md-2">
                    {{$t('sale.schedule.principal')}}
                  </div>
                  <div class="col-md-2">
                    {{$t('sale.schedule.balance')}}
                  </div>
                </div>
                <div class="row" style="height: 15px;"></div>
                <div>
                  <div class="row" style="padding-top: 10px; padding-bottom: 10px;" v-for="(item, index) in schedule" :key="index" >
                      <div class="col-md-1">
                        {{index+1}}
                      </div>
                      <div class="col-md-3">
                        {{item.pay_date_show}}
                      </div>
                      <div class="col-md-2">
                        {{formatCurrency(item.integer_pay)}}
                      </div>
                      <div class="col-md-2">
                        {{formatCurrency(item.interest)}}
                      </div>
                      <div class="col-md-2">
                        {{formatCurrency(item.principal)}}
                      </div>
                      <div class="col-md-2">
                        {{formatCurrency(item.balance)}}
                      </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
</template>